import { useEffect, useState } from "react";
import { Trophy, Medal } from "lucide-react";
import { api } from "@/lib/api";
import { getStudent } from "@/lib/student";

const MEDALS = ["bg-[var(--sun)]", "bg-neutral-200", "bg-orange-300"];

export default function Leaderboard() {
  const me = getStudent();
  const [classes, setClasses] = useState([]);
  const [classId, setClassId] = useState(me?.class_id || "");
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/classes").then((r) => {
      setClasses(r.data);
      if (!r.data.some((c) => c.id === classId) && r.data[0]) setClassId(r.data[0].id);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (classId) api.get("/leaderboard", { params: { class_id: classId } }).then((r) => setData(r.data));
  }, [classId]);

  return (
    <main className="mx-auto max-w-3xl px-5 pb-24 pt-10 sm:px-8" data-testid="leaderboard-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-extrabold uppercase tracking-widest text-neutral-600">Questa settimana</p>
          <h1 className="font-display text-4xl font-bold sm:text-5xl">Classifica</h1>
        </div>
        <select value={classId} onChange={(e) => setClassId(e.target.value)} data-testid="leaderboard-class-select" className="ink-box-sm rounded-full bg-white px-4 py-2 font-extrabold">
          {classes.length === 0 && <option value="">Nessuna classe</option>}
          {classes.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      <p className="mt-2 text-sm text-neutral-600">Ogni risposta giusta vale un punto. La classifica riparte ogni lunedì: tutti possono vincere!</p>

      {data && data.rows.length === 0 && (
        <p className="ink-box mt-8 rounded-3xl bg-white p-10 text-center font-bold" data-testid="leaderboard-empty">Nessun punto ancora questa settimana. Sii il primo!</p>
      )}
      <ol className="mt-8 space-y-3" data-testid="leaderboard-list">
        {data?.rows.map((r, i) => {
          const mine = me && me.class_id === classId && me.name.toLowerCase() === r.name.toLowerCase();
          return (
            <li key={r.name} data-testid={`leaderboard-row-${i}`} className={`ink-box-sm rise flex items-center gap-4 rounded-2xl px-4 py-3 ${mine ? "bg-amber-100" : "bg-white"}`} style={{ animationDelay: `${i * 40}ms` }}>
              <span className={`font-display flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-[var(--ink)] text-lg font-bold ${MEDALS[i] || "bg-white"}`}>
                {i < 3 ? <Medal className="h-5 w-5" /> : i + 1}
              </span>
              <span className="font-display flex-1 text-lg font-bold">{r.name}{mine && <span className="ml-2 text-xs font-extrabold uppercase">(tu)</span>}</span>
              <span className="hidden text-xs font-bold text-neutral-500 sm:inline">{r.quizzes} quiz · record {r.best_pct}%</span>
              <span className="flex items-center gap-1 font-display text-xl font-bold"><Trophy className="h-4 w-4" />{r.points}</span>
            </li>
          );
        })}
      </ol>
    </main>
  );
}
